import { Button, Chip, CircularProgress, Stack, Tooltip, Typography } from "@mui/material";
import { FunctionComponent, useContext, useState } from "react";
import { useSnackBar } from "../../../../contexts/snackbar";
import { API_ENDPOINT } from "../../../../configurations/global.config";
import { AuthContext } from "../../../../contexts/user-context/user-context";
import axios from "axios";
import { IconWithText } from "../../../common/styles/components";
import { Check, CheckCircle, Outbox, ScheduleSend } from "@mui/icons-material";
import { orange } from "@mui/material/colors";

interface MerchantInvitationProps {
    initializationAttempted: boolean
    connected: boolean
    merchantId: string
    onSuccess: () => void
    
}
 
const MerchantInvitation: FunctionComponent<MerchantInvitationProps> = ({initializationAttempted, merchantId, onSuccess, connected}) => {
    const [isLoading, setIsLoading] = useState(false)
    const { showMessage} = useSnackBar()
    const { config } = useContext(AuthContext)

    const sendInvitation = async () => {
                        try {
                        setIsLoading(true);

                        await axios.post(
                            `${API_ENDPOINT}/api/v1/merchant/${merchantId}/invite/`,
                            {},
                            config
                        );
                        showMessage("Invitation sent successfully.");
                        onSuccess()
                        } catch (e: any) {
                        showMessage("Failed to send invitation", "error");
                        console.error(e);
                        } finally {
                        setIsLoading(false);
                        }
                    }

    if (connected) {
        return <IconWithText centered><CheckCircle color="success" />  <Typography variant="body1" color={"green"}>Connected</Typography></IconWithText>
    }

    return   <div>
    { initializationAttempted && <IconWithText centered><Outbox  color='warning'/> <Typography variant="body1" color={orange[900]}> Invited </Typography></IconWithText> }
                              
                              
        <Chip size="small" sx={{p:1}} icon={isLoading ? <CircularProgress size={20}/> : <ScheduleSend />} label={initializationAttempted ? "New Invitation" : "Send Invitation"} onClick={sendInvitation}/>

    </div>

}
 
export default MerchantInvitation;